import { HStack, IconButton, VStack } from '@genial/components';
import React from 'react';

import { MultipleAccountsSelection } from '../../../../components/MultipleAccountsSelection';
import { TableContent, TableContentItemText } from '../../../../components/TableContent';

import { CustomerAccountStatus } from './shared/CustomerAccountStatus';
import { CustomerName } from './shared/CustomerName';

import { CustomerTableItemTypes } from '.';

export const CustomerTableItemTablet: React.FC<CustomerTableItemTypes.Props> = ({
  customer,
  customerDetailHref,
  customerDetailNavigation,
  accountSelected,
  setAccountSelected,
}) => {
  return (
    <TableContent direction="row" space={0} p={0}>
      <HStack
        padding="inset.xs"
        space="inline.quarck"
        w="full"
        justifyContent="space-between"
        alignItems="center">
        <VStack space="stack.quarck" w="2/5">
          <CustomerName customer={customer} />
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText variant="semibold">Conta de custódia</TableContentItemText>
          <MultipleAccountsSelection
            accounts={customer.accountsNormalized}
            accountSelected={accountSelected}
            setAccountSelected={setAccountSelected}
          />
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText color="neutral.black">CPF/CNPJ</TableContentItemText>
          <TableContentItemText>{customer.cpfCnpjNormalized}</TableContentItemText>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            {customer.personTypeNormalized}
          </TableContentItemText>
        </VStack>

        <VStack space="stack.quarck" w="1/6">
          <TableContentItemText color="neutral.black">Cadastro</TableContentItemText>
          <CustomerAccountStatus customer={customer} />
          <TableContentItemText color="neutral.medium" fontSize="xs">
            {customer.accountDateNormalized}
          </TableContentItemText>
        </VStack>

        <IconButton
          onPress={customerDetailNavigation}
          testId="customers-table-item-tablet-action"
          icon="ChevronRight"
          iconSize="xxs"
          iconColor="brand.tertiary.principal"
          href={customerDetailHref}
        />
      </HStack>
    </TableContent>
  );
};
